import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _SIDE_BLOCK_COMPONENT;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { SideBlockHousePickerContainer } from '../../containers/side_block_house_picker';
import { MVKPhase } from '../../types/mvk_state';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
var SIDE_BLOCK_COMPONENTS = (_SIDE_BLOCK_COMPONENT = {}, _defineProperty(_SIDE_BLOCK_COMPONENT, MVKPhase.PREVIEW, SideBlockHousePickerContainer), _defineProperty(_SIDE_BLOCK_COMPONENT, MVKPhase.SECTION, SideBlockHousePickerContainer), _defineProperty(_SIDE_BLOCK_COMPONENT, MVKPhase.FLAT, SideBlockHousePickerContainer), _SIDE_BLOCK_COMPONENT);
export var SideBlock = /*#__PURE__*/function (_React$Component) {
  _inherits(SideBlock, _React$Component);
  var _super = _createSuper(SideBlock);
  function SideBlock() {
    _classCallCheck(this, SideBlock);
    return _super.apply(this, arguments);
  }
  _createClass(SideBlock, [{
    key: "render",
    value: function render() {
      var currentPhase = this.props.currentPhase;
      var CurrentSideBlockContainer = SIDE_BLOCK_COMPONENTS[currentPhase];
      return /*#__PURE__*/_jsx("div", {
        className: styles['container'],
        children: CurrentSideBlockContainer && /*#__PURE__*/_jsx(CurrentSideBlockContainer, {})
      });
    }
  }]);
  return SideBlock;
}(React.Component);